<div id="managewgs" class="subBlockContainer managesubscriptiondetails">
  <child-header [title]="details?.customer?.out_company_name" (closeEvent)="close()"></child-header>
  <div class="subBlockContent">
    <div class="title-wrapper">
      <img class="page-title-img" [src]="details?.annuityType?.logo">
    </div>
    <div class="item-title-wrapper">
      <mat-accordion multi>
        <!-- End User Details -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text"> END USER DETAILS </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text"> NAME:&nbsp; </span><span>{{ details?.customer?.out_company_name }}</span>
              <span class="highlight-text"> | TENANT ID:&nbsp; </span><span>{{ details?.customer?.out_tenant_id }}</span>
              <span class="highlight-text"> | STATUS:&nbsp; </span><span>{{ details?.customer?.out_status_desc }}</span>
              <mat-spinner *ngIf="isSubscriptionResponseLoading" diameter="20" mode="indeterminate" class="circle cSPCustomerEntitlements-loading"></mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <dd-wgs-end-user-details
            [details]="details?.customer"
            [isSubscriptionResponseLoading]="isSubscriptionResponseLoading"
          ></dd-wgs-end-user-details>
        </mat-expansion-panel>

        <!-- Tenant Management -->
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text"> TENANT MANAGEMENT </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
            </mat-panel-description>
          </mat-expansion-panel-header>

          <dd-wgs-tenant-managements></dd-wgs-tenant-managements>
        </mat-expansion-panel>

        <!-- Subscription -->
        <mat-expansion-panel [expanded]="!isWGSItemLoading">
          <mat-expansion-panel-header>
            <mat-panel-title class="highlight-text">
              SUBSCRIPTION
            </mat-panel-title>
            <mat-panel-description class="panel-subtitle">
              <span class="highlight-text"> {{ WGSTableListItems?.length ? WGSTableListItems.length : "0" }} Subscription(s) </span>
              <mat-spinner
                *ngIf="isWGSItemLoading"
                mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading"
                diameter="20"
              >
              </mat-spinner>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div style="font-size: 12px;">
            <div class="panel-body">
              <div *ngIf="WGSTableListItems?.length && !isWGSItemLoading">
                <div class="mTable">
                  <table class="table" mat-table [dataSource]="WGSTableListItems" style="margin-bottom: unset;">

                    <!-- Desc Column -->
                    <ng-container matColumnDef="desc">
                      <th mat-header-cell *matHeaderCellDef width="50%" class="table-cell"> DESCRIPTION </th>
                      <td class="push-left-75 table-cell" mat-cell *matCellDef="let sub">
                        <span class="description">{{ sub?.subscriptionListView?.out_stk_description }}</span>
                          
                        <div class="result-info">
                          <div class="produc-secondary-title-wrapper">
                            <span>RESELLER ID:&nbsp;</span>
                            <span class="cursor-pointer red-bold">{{ sub?.subscriptionListView?.out_mpnid }}&nbsp;</span>
                            <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span>DESC:&nbsp;</span>
                            <span class="cursor-pointer red-bold">{{ sub?.subscriptionListView?.out_sub_description }}</span>
                          </div>
                          <div class="produc-secondary-title-wrapper">
                            <span>STOCK CODE:&nbsp;</span>
                            <span class="red-bold">{{ sub?.subscriptionListView?.out_stock_code }}</span>

                            <div class="result-info" *ngIf="sub?.subscriptionDetailView" >
                              <span>TERM START:&nbsp;</span> <span class="red-bold">{{sub?.subscriptionDetailView?.termBillingStartDate | date: 'dd/MM/yyyy' }}&nbsp;&nbsp;</span>
                              <span>END:&nbsp;</span> <span class="red-bold">{{sub?.subscriptionDetailView?.termBillingEndDate | date: 'dd/MM/yyyy' }}</span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </ng-container>

                    <!-- UserCount Column -->
                    <ng-container matColumnDef="userCount">
                      <th mat-header-cell *matHeaderCellDef class="align-center table-cell" width="10%"> USER COUNT </th>
                      <td mat-cell *matCellDef="let sub;" class="align-center align-top table-cell">
                        <span *ngIf="sub?.subscriptionDetailView"> {{ sub?.subscriptionDetailView?.userCount }} </span>
                      </td>
                    </ng-container>

                    <!-- Status Column -->
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef class="align-center table-cell" width="10%"> STATUS </th>
                      <td mat-cell *matCellDef="let sub;" class="align-center align-top table-cell">
                        <span *ngIf="sub?.subscriptionDetailView"> {{ sub?.subscriptionDetailView?.subscriptionStatus }} </span>
                      </td>
                    </ng-container>

                    <!-- Price Column -->
                    <ng-container matColumnDef="price">
                      <th mat-header-cell *matHeaderCellDef class="align-right table-cell" width="10%"> PRICE </th>
                      <td mat-cell *matCellDef="let sub;" class="align-right push-left-75 table-cell">
                        {{ sub?.subscriptionListView?.out_price | currency:'AUD':'symbol-narrow':'.2-2'}}
                        <span>/mth</span>
                      </td>
                    </ng-container>

                    <!-- Total Column -->
                    <ng-container matColumnDef="total">
                      <th mat-header-cell *matHeaderCellDef class="align-right table-cell" width="10%"> TOTAL </th>
                      <td mat-cell *matCellDef="let sub;" class="align-right push-left-75 table-cell">
                        {{ sub?.subscriptionListView?.out_amount | currency:'AUD':'symbol-narrow':'.2-2'}}
                        <span>/mth</span>
                      </td>
                    </ng-container>

                    <!-- Manage Button Column -->
                    <ng-container matColumnDef="manageBtn">
                      <th mat-header-cell *matHeaderCellDef width="10%" class="table-cell"></th>
                      <td mat-cell *matCellDef="let sub;" class="align-center table-cell">
                        <button
                          *ngIf="sub?.subscriptionDetailView"
                          class="button button-red button-round"
                          (click)="manageSubscription(sub?.subscriptionDetailView)">Manage
                        </button>
                        <mat-spinner *ngIf="!sub?.subscriptionDetailView"  mode="indeterminate" class="circle" style="margin: 15px auto;"  diameter="20">
                        </mat-spinner>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


                    <!-- Group header -->
                    <!-- <ng-container matColumnDef="groupHeader">
                      <td colspan="999" mat-cell *matCellDef="let groupBy"><strong>{{groupBy.course}}</strong></td>
                    </ng-container>

                    <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"> </tr> -->
                    <!-- dataSource = STUDENT_DATA.reduce((acc, {course, students}) => ([...acc, {course, isGroupBy: true}, ...students]),[]) -->
                  </table>
                  <!-- table footer -->
                  <div class="row totalPrice-wrapper">
                    <!-- <div class="col align-right" *ngIf="pendingTotal != 0">
                      <span><b>Pending Total (Ex GST) </b>
                        <span class="pendingTotal">{{ pendingTotal |
                          currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                    </div>
                    <div class="col align-right" *ngIf="pendingTotal == 0">
                      <span><b>Pending Total (Ex GST) </b>
                        <span class="pendingTotal">{{ 0 |
                          currency:'AUD':'symbol-narrow':'.2-2'}}</span></span>
                    </div> -->
                    <div class="col align-center">
                      <span><b>Active Total (Ex GST) </b>
                        <span class="activeTotal">{{activeTotal |
                          currency:'AUD':'symbol-narrow':'.2-2'}}<span>/mth</span></span></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <div class="col button-center" style="margin-bottom: 20px;">
                  <button class="button button-red button-large button-center-left"
                    (click)="getWGSProductList();">Add new product</button>
                </div>
              </div> -->
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
